/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/State/Prompts
 * @desc Prompts for unsaved changes
 */

import type React from 'react';
import { Prompt } from 'react-router-dom';
import { getMessage } from '../utils';
import type { ExperimentFormShowEditStatePromptsProps } from './types';

export const ExperimentFormShowEditStatePrompts: React.FC<
  ExperimentFormShowEditStatePromptsProps
> = ({ status, experiment, experimentWorkflow, conflict }) => {
  if (!status || !status.fields?.includes('state')) {
    return null;
  }

  return (
    <>
      <Prompt
        when={!!conflict}
        message="Copy any unsaved changes before leaving the page"
      />
      <Prompt
        when={status.isFetching || !!status.error}
        message={getMessage(experiment, experimentWorkflow)}
      />
    </>
  );
};
